


















import PlanningsListDetail from "./PlanningsListDetail.vue";
import Accordion from "../../core/UI/Accordion.vue";
import CollapsiblePanel from "../../core/UI/CollapsiblePanel.vue";

export default {
    name: "PlanningsList",
    components: { CollapsiblePanel, Accordion, PlanningsListDetail },
    props: {
        plannings: Array,
    },
    methods: {
        editPlanning(planningId: number) {
            this.$emit("edit-planning", planningId);
        },
        onPlanningDeleted(planningId: number) {
            this.$emit("planning-deleted");
        },
    },
};
